import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { getToken } from 'Features/auth/auth'
import { msalInstance } from './msal-instance'
const client = axios.create({
  baseURL: process.env.PLANNER_BASE_URL,
})

client.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      toast.dismiss()
      toast.error('You are not authorized to access this resource.')
      // const tokenRequest = {
      //   scopes: ['User.Read'], // Add the scopes your app needs
      //   account: msalInstance?.getActiveAccount() ?? undefined, // Use the logged-in account
      // }
      // msalInstance.acquireTokenRedirect(tokenRequest)
    }
    return Promise.reject(error)
  }
)

export const request = async (
  options: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const token = await getToken()
  client.defaults.headers.common.Authorization = `Bearer ${token?.idToken}`
  const tenantId = localStorage.getItem('tenantId')
  if (tenantId) {
    client.defaults.headers.common.Tenant = tenantId
  }
  return client(options)
}
